<template>
  <div class="relative -mx-4 -my-1">
    <!-- Fade left -->
    <div
      class="absolute top-0 left-0 h-full w-4 bg-linear-to-r from-gray-50 to-gray-50/0"
    />
    <!-- Scrollable KPIs -->
    <HorizontalScrollWrapper>
      <div class="flex gap-2 py-1 pl-4 *:min-w-48 *:flex-1 *:shrink-0 lg:gap-4">
        <slot />
        <!-- Spacer since padding is ignored by the scroll container -->
        <div class="w-2 min-w-0! flex-none! lg:w-0" />
      </div>
    </HorizontalScrollWrapper>
    <!-- Fade right -->
    <div
      class="absolute top-0 right-0 h-full w-4 bg-linear-to-l from-gray-50 to-gray-50/0"
    />
  </div>
</template>

<script setup>
import HorizontalScrollWrapper from "@/components/utilities/HorizontalScrollWrapper.vue"
</script>
